module.exports = __webpack_public_path__ + "img/0Q3A0072_L_BlackMatted.c4241fb2.jpg";